export type DateLike = Date | number | string | null | undefined;

// int64 wire fields reach the browser either as a number or as a decimal
// STRING (protobuf-JSON encodes 64-bit integers as strings to survive the
// float53 limit). `new Date('1670568642000')` is an Invalid Date, so a
// digits-only string has to be read as an epoch — which is exactly what the
// legacy `parseInt(time)` call sites did.
const EPOCH_STRING = /^-?\d+$/;

function toEpochMillis(value: number | string): number | null {
  if (typeof value === 'number') return value;
  return EPOCH_STRING.test(value.trim()) ? Number(value.trim()) : null;
}

export function formatDateTime(value: DateLike, fallback = '-'): string {
  if (value === null || value === undefined || value === '') return fallback;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? fallback : value.toLocaleString();
  }
  const epoch = toEpochMillis(value);
  // A timestamp of 0 / negative means "unset" everywhere in this app (matches
  // legacy `timeToStr`, which rendered these as '-'), NOT the 1970 epoch.
  // Guard it here so every caller treats an empty timestamp the same.
  if (epoch !== null && epoch <= 0) return fallback;
  const date = new Date(epoch ?? value);
  return Number.isNaN(date.getTime()) ? fallback : date.toLocaleString();
}
